import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import StaffDatabase from "./pages/Staff-Database"
import FormDatabase from "./pages/Form-Database"
import Email from "./pages/Email";
import RecycleBin from "./pages/Recyclebin";

import Footer from "./components/Footer";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/staff-db" element={<StaffDatabase />} />
        <Route path="/form-db" element={<FormDatabase />} />
        <Route path="/send-off" element={<Email />} />
        <Route path="/recyclebin" element={<RecycleBin />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
      <Footer />
    </>
  );
}